import { createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "empty-channel" }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "flex-shrink-0 logo-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-grow-1\"><h5 class=\"mb-3 mt-4\"> Welcome to the Chat Channel!</h5><p class=\"mb-3\"> You can start chatting by typing your message in the box below and pressing send.</p><p>As the conversation grows, use the icons next to each message to manage the discussion:</p><p><i class=\"fa fa-comment-dots\"></i> <strong>Start a threaded conversation </strong>to keep related replies together.</p><p><i class=\"fa fa-edit\"></i> <strong>Edit your message </strong>if you need to make changes.</p><p><i class=\"fa fa-share\"></i> <strong>Forward a message</strong> to this channel or bring up a past topic.</p><p><i class=\"fa fa-trash\"></i> <strong>Remove your message </strong>from the channel.</p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.imageBaseUrl
          ? `${_ctx.state.imageBaseUrl}img/convorally-logo1.png`
          : '/img/no-user.jpg',
            alt: "Logo"
          }, null, 8, ["src"])
        ]),
        _hoisted_5
      ])
    ])
  ]))
}